<nr-nav-bar></nr-nav-bar>

<div class="app-body container-fluid">
	<router-outlet></router-outlet>
</div>

<nr-footer></nr-footer>
